// This file should include all tests running in the form of
// export const [TEST_NAME] = [TEST_NUMBER]
module.exports = {
    LAYOUT_PERFORMANCE_FE_GUILD: 4303,
    DOLPHINS_LOHP_PRO_PACKAGES: 4899,
    DOLPHINS_TOF_PRO_REDIRECT: 4831,
    MUSTANGS_LOHP_LONG_TERM_HIRING_EXPERIMENT: 4923,
    LYNXES_EXPANDABLE_SEARCH_BAR: 5034,
    LYNXES_BRAND_LOHP: 5011,
    LYNXES_BUYER_PROFILE_REDESIGN: 4935,
    LYNXES_SEAMLESS_ONBOARDING_AND_ROUTING_V4: 5010,
    LYNXES_VISIBLE_CATEGORY_BAR: 5019,
    LYNXES_HEADER_NEW_JOIN_BUTTON: 5021,
};
